import {Component} from '@angular/core';
import { CmsComponentData, SpinnerComponent, FormErrorsComponent } from '@spartacus/storefront';
import {ForgotPasswordComponentData} from '../../../login-register/model/login-register.model';
import {
  ForgotPasswordComponent,
  ForgotPasswordComponentService,
} from '@spartacus/user/profile/components';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { RouterLink } from '@angular/router';
import { AsyncPipe } from '@angular/common';
import { TranslatePipe, UrlPipe } from '@spartacus/core';

@Component({
    selector: 'app-efa-forgot-password',
    templateUrl: './efa-forgot-password.component.html',
    imports: [SpinnerComponent, FormsModule, ReactiveFormsModule, FormErrorsComponent, RouterLink, AsyncPipe, TranslatePipe, UrlPipe]
})
export class EfaForgotPasswordComponent extends ForgotPasswordComponent {
  constructor(
    public component: CmsComponentData<ForgotPasswordComponentData>,
    protected service: ForgotPasswordComponentService
  ) {
    super(service);
  }
}
